import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { TextField, Typography } from '@mui/material';
import FormSelect from '../form-select/select';
import Autocomplete from '@mui/material/Autocomplete';
import weglotTranslationInfo from '../../config/WeglotLanguageTranslation.json';
import moment from 'moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import languageData from '../../config/WeglotLanguageTranslation.json';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import 'dayjs/locale/nl';
import 'dayjs/locale/de';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/ko';
import 'dayjs/locale/it';
import 'dayjs/locale/bg';
import 'dayjs/locale/hr';
import 'dayjs/locale/tr';
import 'dayjs/locale/da';
import 'dayjs/locale/sv';
import 'dayjs/locale/cs';
import 'dayjs/locale/he';
import 'dayjs/locale/ga';
import 'dayjs/locale/sk';
import 'dayjs/locale/th';
import 'dayjs/locale/uk';
import 'dayjs/locale/nb';
import 'dayjs/locale/fa';
import 'dayjs/locale/el';
import 'dayjs/locale/fi';
import 'dayjs/locale/bs';
import 'dayjs/locale/pl';
import 'dayjs/locale/sl';
import 'dayjs/locale/ja';
import 'dayjs/locale/ar';
import { sortTranslated } from '../shared/util';


const TextComponent = (props) => {
    const [inputState, setInputState] = useState('');
    const [operationValue, setOperationValue] = useState('Equals')    
    const [numberRange, setNumberRange] = useState(false);
    const [hideInput, setHideInput] = useState(false);
    const [minValue, setMinValue] = useState();
    const [maxValue, setMaxValue] = useState();
    const [minDate, setMinDate]= useState(null)
    const [maxDate, setMaxDate]= useState(null)
    const [languageCodeData, setLanguageCodeData ] = useState(languageData);
    const [languageCode, setLanguageCode] = useState()
    

    
    useEffect(() => {        
        
        let indexInput = props.id;
        let formDetails = props.form !== undefined ? (props.form[indexInput] || '') : '';
        let indexKey = props.operationId;

        let formDetailsOpration = props.form !== undefined ? (props.form[indexKey] !== undefined ? props.form[indexKey] : 'Equals') : 'Equals';
        let minFormValue = '';
        let maxFormValue = '';
        let formNumberRange = false;
        if (formDetailsOpration === 'In Range') {
            formNumberRange = true;
            if (!isNaN(formDetails[0])) {
                if (parseFloat(formDetails[0]) > parseFloat(formDetails[1])) {
                    minFormValue = formDetails[1];
                    maxFormValue = formDetails[0];
                } else {
                    minFormValue = formDetails[0];
                    maxFormValue = formDetails[1];
                }
            } else if (isNaN(formDetails[0]) && formDetails !== '') {
                if (moment.utc(new Date(formDetails[0])).isAfter(new Date(formDetails[1]))) {
                    minFormValue = formDetails[1];
                    maxFormValue = formDetails[0];
                } else {
                    minFormValue = formDetails[0];
                    maxFormValue = formDetails[1];
                }
            }
        }

        setInputState(formDetails);
        setOperationValue(formDetailsOpration);

        setNumberRange(formNumberRange);
        setHideInput(formDetailsOpration === 'Exists' || formDetailsOpration === 'Not Exists');
        setMinValue(minFormValue);
        setMaxValue(maxFormValue);

        var localLanguageCode = languageCodeData?.calendarLocales[window.Weglot.getCurrentLang()]        
        
        if(localLanguageCode !== undefined)
        {
            setLanguageCode(localLanguageCode?.dayjs_locale)    
        }
        else{
            setLanguageCode("en")    
        }                 
                   

    }, [props.form, props.id, props.operationId])

    useEffect(() => {
        if (props.clear === true) {
            setOperationValue('Equals');
            setInputState('');
            setHideInput(false);
            setNumberRange(false);
        }
    }, [props.clear])
   

    window.Weglot.on("languageChanged", function languageChanger(newLang, prevLang) {        
        
        var localLanguage = languageCodeData?.calendarLocales[newLang];
        
        
        if(localLanguage !== undefined)
        {
            setLanguageCode(localLanguage?.dayjs_locale)    
        }
        else{
            setLanguageCode("en")    
        }                 
                   
    })
    

    /*
    Handele change in Text 
    @event : event of Text Change
    @value: text value
    @name: name of textbox changes
    */
    const handleInputText = (event, value, name) => {

        if (name !== undefined) {
            value.indexOf('') >= 0 && (value.splice(value.indexOf(''), 1));
            setInputState(value);
        } else {
            setInputState(event.target.value);
        }
    }

    /*
    Passing value to Parent component
    event :  final blur event
    value: value of text box
    name: name of attribute to pass to parent component
    */
    const sentItToParent = (event, value, name) => {
        if (name !== undefined) {
            value.indexOf('') >= 0 && (value.splice(value.indexOf(''), 1));
            setInputState(value);
            props.handeltextChange({ target: { name: name, value: value.flatMap(val => val?.split(' | ').length ? val.split(' | ')[val.split(' | ').length - 1] : val) } });
        } else {
            setInputState(event.target.value);
            props.handeltextChange({ target: { name: event.target.name, value: event.target.value } });
        }
    }


    const handledate =(event,id)=>{
       
        const year = event.$y
        const month = (event.$M < 9 ? '0'+(event.$M+1)  : event.$M+1 )
        const day = (event.$D < 10 ? '0'+event.$D  : event.$D )

      
        setInputState(`${year}-${month}-${day}`)
        props.handeltextChange({ target: { name: id, value: `${year}-${month}-${day}` } });
           
       
    }

    const handledMinMax =(event,id,type)=>{
       
        const year = event.$y
        const month = (event.$M < 9 ? '0'+(event.$M+1)  : event.$M+1 )
        const day = (event.$D < 10 ? '0'+event.$D  : event.$D )

       if(type == 'min')
       {
        setMinDate(`${year}-${month}-${day}`)
       
       }
       else
       {
        
        setMaxDate(`${year}-${month}-${day}`)
       }
       
     
       handleInputText({ target: { name:id, value: [minDate, maxDate] } });
       sentItToParent({ target: { name:id, value: [minDate, maxDate] } });      
       
    }

    /*
    handle the Opration menu
    @event: click event
    */
    const changeOperation = (event) => {
        if (event.target.value === 'In Range' && (props.type === 'inputnumber' || props.type === 'date')) {
            changeMin({ target: { value: '' } });
            changeMax({ target: { value: '' } });
            handleInputText({ target: { name: props.id, value: '' } })
            sentItToParent({ target: { name: props.id, value: '' } })
            setNumberRange(true);
            setHideInput(false);
        } else if (event.target.value === 'Exists' || event.target.value === 'Not Exists') {
            setHideInput(true);
            let name = props.id;
            handleInputText({ target: { name: name, value: 'Not Exist' } })
            sentItToParent({ target: { name: name, value: 'Not Exist' } })
        }
        else {
            setNumberRange(false);
            setHideInput(false);
            handleInputText({ target: { name: props.id, value: '' } })
            sentItToParent({ target: { name: props.id, value: '' } })

        }
        setOperationValue(event.target.value);
        props.handeltextChange(event);
    }

    /**S
     * 
     * @param {*} event :handel the input change of number 
     */
    const numberChange = (event) => {

        if (parseFloat(maxValue) < parseFloat(minValue) && maxValue?.length !== 0 && minValue?.length !== 0) {
            let max = maxValue;
            setMaxValue(minValue);
            setMinValue(max);
        }
        handleInputText({ target: { name: props.id, value: [minValue, maxValue] } });
        sentItToParent({ target: { name: props.id, value: [minValue, maxValue] } });
    }

    /**
     * 
     * @param {*} event handels the In Range operation change for min 
     */
    const changeMin = (event) => {
        setMinValue(event.target.value);

    }

    /**
     * 
     * @param {*} event handle the in range operation change value for max
     */
    const changeMax = (event) => {
        setMaxValue(event.target.value);
    }

    /**
     * 
     * @param {*} event Handle the date chnage 
     */
    const dateChange = (event) => {
        if (moment.utc(new Date(minValue)).isAfter(new Date(maxValue)) && maxValue?.length !== 0 && minValue?.length !== 0) {
            let max = maxValue;
            setMaxValue(moment.utc(new Date(minValue)).format('YYYY-MM-DD'));
            setMinValue(moment.utc(new Date(max)).format('YYYY-MM-DD'));

        }
        handleInputText({ target: { name: props.id, value: [minValue, maxValue] } });
        sentItToParent({ target: { name: props.id, value: [minValue, maxValue] } });

    }

    const disableTranslation = weglotTranslationInfo.labelExclusionList.includes(props.name?.toLowerCase());

    return (
        <>
            {
                ((props.entity === props.dataType) || (props.dataType === 'both'))
                &&
                <Grid container spacing={2} alignItems="flex-start">
                    {
                        props.type === 'labelonly' &&
                        <Grid item x={12} className=' mt-4 pt-2' alignItems="flex-start">
                            <Typography variant='subtitle1' className={`fw-bold ${disableTranslation ? '_wg-exclude':''}`} id="advance-tab" alignItems="flex-start">{props.name} : </Typography>
                        </Grid>
                    }
                    {
                        props.type !== 'labelonly' &&
                        <>
                            <Grid item xs={4} >
                                <label id="advance-tab" className={`${disableTranslation ? "_wg-exclude":''}`}>{props.name}</label>
                            </Grid>
                            <Grid item xs={3} >
                                <FormSelect
                                    key={props.operationId}
                                    name={props.operationId}
                                    selectLabel='Operation'
                                    onSelectValue={changeOperation}
                                    selectData={props.operations}
                                    defaultValue={operationValue}
                                    
                                    
                                />
                            </Grid>
                            {
                                !hideInput &&
                                <>
                                    {
                                        props.type?.toUpperCase() === 'DATE' && numberRange &&
                                        <>
                                            <Grid item xs={2.5} className='pt-3 w-100'>
                                                

                                                    <LocalizationProvider  dateAdapter={AdapterDayjs} adapterLocale={languageCode} >
                                                    <DatePicker
                                                       
                                                        id={props.id}                                                  
                                                        openTo="year" 
                                                        name='min'                                                       
                                                        sx={{padding:'5px', width:"100%"}}                                                                                                                                                     
                                                        views={['year', 'month', 'day']}
                                                        onChange={(event)=>handledMinMax(event,props.id,'min')}
                                                        slotProps={{ textField: { size: 'small' } }}
                                                        className="calandar"
                                                        value={minDate}  
                                                    />


                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                    <LocalizationProvider  dateAdapter={AdapterDayjs} adapterLocale={languageCode} >
                                                    <DatePicker
                                                        id={props.id}                                                  
                                                        openTo="year" 
                                                        name='min'                                                       
                                                        sx={{padding:'5px', width:"100%"}}                                                                                                                                                     
                                                        views={['year', 'month', 'day']}
                                                        onChange={(event)=>handledMinMax(event,props.id,'max')}
                                                        slotProps={{ textField: { size: 'small' } }}
                                                        className="calandar"  
                                                        value={maxDate}                                                                                               
                                                    />

                                                </LocalizationProvider>
                                            </Grid>
                                        </>

                                    }

                                    {
                                        props.type?.toUpperCase() === 'INPUTNUMBER' && numberRange &&
                                        <>
                                            <Grid item xs={5} className='pt-3 w-100'>
                                                <TextField
                                                    type='number'
                                                    key={props.operationId}
                                                    value={(minValue || '')}
                                                    onChange={changeMin}
                                                    onBlur={numberChange}
                                                    id={props.id}
                                                    variant="standard"
                                                    name='min'
                                                    color="primary" className="w-100 mb-3" />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <TextField
                                                    type='number'
                                                    key={props.operationId}
                                                    value={(maxValue || '')}
                                                    onChange={changeMax}
                                                    onBlur={numberChange}
                                                    variant="standard"
                                                    id={props.id}
                                                    name='max'
                                                    color="primary" className="w-100 mb-3" />
                                            </Grid>
                                        </>

                                    }
                                    <Grid item xs={5} className='pt-3'>
                                        {
                                            props.type?.toUpperCase() === 'INPUT' &&
                                            <TextField
                                                key={props.operationId}
                                                value={(inputState || '')}
                                                onChange={handleInputText}
                                                onBlur={sentItToParent}
                                                variant="standard"
                                                id={props.id}
                                                name={props.id}
                                                color="primary" className="w-100 mb-3" />
                                        }
                                        {
                                            props.type?.toUpperCase() === 'INPUTNUMBER' && !numberRange &&
                                            <TextField
                                                type='number'
                                                key={props?.operationId}
                                                value={(inputState || '')}
                                                onChange={handleInputText}
                                                variant="standard"
                                                onBlur={sentItToParent}
                                                id={props.id}
                                                name={props.id}
                                                color="primary" className="w-100 mb-3" />
                                        }
                                        {
                                            props.type?.toUpperCase() === 'SELECT' &&
                                            <Autocomplete
                                                value={inputState?.length === 0 ? [] :
                                                    inputState.flatMap(val => props.fieldOption.find(opt => opt.split(' | ')[opt.split(' | ').length - 1] == val))}
                                                multiple={true}
                                                disableCloseOnSelect
                                                className="mb-3"
                                                limitTags={3}
                                                key={props.operationId}
                                                getOptionLabel={(val) => val?.split(' | ').length ? val?.split(' | ')[0] : val}
                                                onChange={(event, value) => sentItToParent(event, value, props.id)}
                                                options={props.fieldOption ? sortTranslated(props.fieldOption) : props.fieldOption}
                                                id={props.id}
                                                name={props.id}
                                                renderInput={(params) =>
                                                    <TextField 
                                                    variant="standard"
                                                   
                                                    {...params} />}
                                            />
                                        }
                                        {
                                            props.type?.toUpperCase() === 'DATE' && !numberRange &&
                                            
                                            <LocalizationProvider  dateAdapter={AdapterDayjs} adapterLocale={languageCode} >
                                                    <DatePicker
                                                        id={props.id}                                                  
                                                        openTo="year"                                                        
                                                        sx={{padding:'5px', width:"100%"}}                                                                                                                                                     
                                                        views={['year', 'month', 'day']}
                                                        onChange={(event)=>handledate(event,props.id)}
                                                        slotProps={{ textField: { size: 'small' } }}
                                                        className="calendar"  
                                                    />

                                                </LocalizationProvider>
                                        }
                                    </Grid>
                                </>
                            }
                        </>
                    }
                </Grid>
            }
        </>

    );
}

export default TextComponent;